module.exports = __webpack_public_path__ + "img/manifest.4c121a8d.jpg";